import { render, staticRenderFns } from "./business-partner-contract-step.vue?vue&type=template&id=6dc4e54d&"
import script from "./business-partner-contract-step.vue?vue&type=script&lang=js&"
export * from "./business-partner-contract-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports